function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "vapours");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-activities-/-cargo-calculation",
  transform: "translate(-2.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M11.9576784,2.00053405 C7.78432674,1.99293762 4.05074311,4.60913339 2.61082588,8.55005819 C1.17090866,12.490983 2.33137603,16.9171765 5.51600184,19.6308274 C8.70062765,22.3444782 13.2310516,22.7675488 16.857707,20.689965 L16.9272814,20.689965 L16.9769775,20.689965 C20.9127444,18.4358447 22.8362915,13.7899665 21.6549812,9.39134078 C20.4736708,4.99271506 16.4862396,1.95369128 11.9576784,2.00053405 Z M12.951599,4.07047103 C16.5497808,4.5295425 19.3831743,7.38017994 19.8394688,11.00026 L12.951599,11.00026 L12.951599,4.07047103 Z M11.9576784,19.999986 C7.78069603,19.9713125 4.3378856,16.6958563 4.07618606,12.5016111 C3.81448652,8.30736585 6.82313042,4.62445714 10.9637578,4.07047103 L10.9637578,12.0002296 C10.9676771,12.1199464 10.9911837,12.2381945 11.0333323,12.3502189 L11.0333323,12.4302165 L11.0333323,12.5002144 L15.0090147,19.3700052 C14.0446583,19.7852647 13.0066511,19.9995723 11.9576784,19.999986 L11.9576784,19.999986 Z M16.7583149,18.3600359 L13.6771611,13.0001991 L19.8394688,13.0001991 C19.5691362,15.1304772 18.4588154,17.0619412 16.7583149,18.3600359 Z",
  id: "vapours"
})));

var SvgVapours = function SvgVapours(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVapours, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vapours.456b9fee.svg";
export { ForwardRef as ReactComponent };